<ng-template *ngComponentOutlet="component; injector: inject"></ng-template>
